<div class="mobilemenu" [ngClass]="{'mobilemenu--open': isOpen,'mobilemenu--close':(mobilemenu.isClose$|async)}">
    <div class="mobilemenu__backdrop" (click)="mobilemenu.close()"></div>
    <div class="mobilemenu__body">
        <div class="mobilemenu__header">
            <div class="mobilemenu__title text-left">{{"menu"|translate}}</div>
            <button type="button" class="mobilemenu__close" (click)="mobilemenu.close()">
                <app-icon name="cross-20" size="12"></app-icon>
            </button>
        </div>

        <div class="d-md-block d-none">
            <div class="mobilemenu__indicators">
                <a class="mobilemenu__indicator" (click)="onItemClick($event)" [routerLink]="['/account/dashboard']">
                    <span class="mobilemenu__indicator-icon">
                        <app-icon name="person-20" size="20"></app-icon>
                    </span>
                    <span class="mobilemenu__indicator-title">{{"profile"|translate}}</span>
                </a>
                <a class="mobilemenu__indicator" (click)="onItemClick($event)" [routerLink]="['/cart']">
                    <span class="mobilemenu__indicator-icon">
                        <app-icon name="cart-20" size="20"></app-icon>
                    </span>
                    <span class="mobilemenu__indicator-title">{{"cart"|translate}}</span>
                </a>
                <a class="mobilemenu__indicator" (click)="onItemClick($event)" [routerLink]="['/account/quotations']">
                    <span class="mobilemenu__indicator-icon">
                        <app-icon name="quotation-20" size="20"></app-icon>
                    </span>
                    <span class="mobilemenu__indicator-title">{{"quotation_list"|translate}}</span>
                </a>
                <a *ngIf="sector && sector != 'homepage'" class="mobilemenu__indicator" (click)="onItemClick($event)" [routerLink]="((sector) ? ['/sector', sector] : ['/']).concat(['site','stores'])">
                    <span class="mobilemenu__indicator-icon">
                        <app-icon name="store-20" size="20"></app-icon>
                    </span>
                    <span class="mobilemenu__indicator-title">{{"stores"|translate}}</span>
                </a>
            </div>



            <div class="mobilemenu__divider"></div>

            <div class="mobilemenu__content">
                <ul class="mobile-links mobile-links--level--{{ 0 }}" appCollapse>
                    <li>
                        <div class="mobile-links__item" appCollapseItem="mobile-links__item--open" #item="appCollapseItem">
                            <div class="mobile-links__item-title" (click)="item.toggle()">
                                <a class="mobile-links__item-link" [routerLink]="[]">{{"sectors"|translate}}</a>
                                <!-- <a class="mobile-links__item-link" (click)="onItemClick(link)">{{ link.label }}</a> -->
                                <button class="mobile-links__item-toggle" type="button">
                                    <app-icon class="mobile-links__item-arrow" name="arrow-rounded-down-12x7" size="12x7">
                                    </app-icon>
                                </button>
                            </div>
                            <div class="mobile-links__item-sub-links" appCollapseContent>
                                <app-mobile-links type="sector" [links]="sectorlinks" [level]="0" (itemClick)="onItemClick($event)">
                                </app-mobile-links>
                            </div>
                        </div>
                        <!-- <div *ngIf="link.type === 'divider'" class="mobile-links__divider"></div> -->
                    </li>
                </ul>
                <ul class="mobile-links mobile-links--level--{{ 0 }}" *ngIf="sector && sector != 'homepage'" appCollapse>
                    <li>
                        <div class="mobile-links__item" appCollapseItem="mobile-links__item--open" #item="appCollapseItem">
                            <div class="mobile-links__item-title" (click)="item.toggle()">
                                <a class="mobile-links__item-link" [routerLink]="[]">{{"categories"|translate}}</a>
                                <!-- <a class="mobile-links__item-link" (click)="onItemClick(link)">{{ link.label }}</a> -->
                                <button class="mobile-links__item-toggle" type="button">
                                    <app-icon class="mobile-links__item-arrow" name="arrow-rounded-down-12x7" size="12x7">
                                    </app-icon>
                                </button>
                            </div>
                            <div class="mobile-links__item-sub-links" appCollapseContent>
                                <app-mobile-links type="category" [links]="categorylinks" [level]="0" (itemClick)="onItemClick($event)">
                                </app-mobile-links>
                            </div>
                        </div>
                        <!-- <div *ngIf="link.type === 'divider'" class="mobile-links__divider"></div> -->
                    </li>
                </ul>
                <!--             <app-menu-items [name]="'Stores'" [url]="'/site/stores'" (itemClick)="onItemClick($event)"></app-menu-items>
    -->
                <!-- <app-languages></app-languages> -->
                <!-- <app-mobile-links [links]="links" (itemClick)="onItemClick($event)"></app-mobile-links> -->
            </div>
        </div>


        <div class="mobilemenu__divider"></div>
        <div class="flex flex-row items-center justify-start">
            <span class="m-3">Language/اللغة:</span>
            <a class="m-2 cursor-pointer" [ngStyle]="{border: '3px'}" [style.border]="'3px'" (click)="changeLangage('en')">
                <span class="">
                    <app-icon [style]="translateService.currentLang == 'en'?{'background-color':'rgb(211, 129, 71)'}:{}" [name]="'en'" size="25"></app-icon>
                </span>

            </a>
            <a class="m-2 cursor-pointer" (click)="changeLangage('ar')">
                <span class="mobilemenu__indicator-icon">
                    <app-icon [style]="translateService.currentLang == 'ar'?{'background-color':'rgb(211, 129, 71)'}:{}" [name]="'ar'" size="25"></app-icon>
                </span>
            </a>
        </div>

        <div class="mobilemenu__divider"></div>

        <a (click)="mobilemenu.close()" *ngIf="!siteService.siteSetting?.companyId" [routerLink]="['/blog']" class="flex flex-row m-3 color-inherit">
            <span class="mobile-links__item-link">
                {{ "blog" | translate}}
            </span>
        </a>

        <div class="mobilemenu__divider"></div>


        <div class="mobilemenu__content" *ngIf="deviceDetector.isMobile()">
            <ul class="mobile-links mobile-links--level--0" appCollapse>
                <li *ngFor="let page of staticPages|keyvalue">
                    <div class="mobile-links__item" appCollapseItem="mobile-links__item--open" #footerLinks="appCollapseItem">
                        <div class="mobile-links__item-title" (click)="footerLinks.toggle()">
                            <div class="mobile-links__item-link">{{page.key}}</div>
                            <!-- <a class="mobile-links__item-link" (click)="onItemClick(link)">{{ link.label }}</a> -->
                            <button class="mobile-links__item-toggle" type="button">
                                <app-icon class="mobile-links__item-arrow" name="arrow-rounded-down-12x7" size="12x7">
                                </app-icon>
                            </button>
                        </div>
                        <div class="mobile-links__item-sub-links" appCollapseContent>
                            <ul class="mobile-links mobile-links--level--1" appCollapse>
                                <li *ngFor="let link of page.value">
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <a class="mobile-links__item-link" [routerLink]="['/page',link?.seo?.slug]">{{
                                                translateHelper.localize(link.name) }}</a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="mobile-links__item" appCollapseItem="mobile-links__item--open" #contactUs="appCollapseItem">
                        <div class="mobile-links__item-title" (click)="contactUs.toggle()">
                            <div class="mobile-links__item-link">{{"contact_us"|translate}}</div>
                            <!-- <a class="mobile-links__item-link" (click)="onItemClick(link)">{{ link.label }}</a> -->
                            <button class="mobile-links__item-toggle" type="button">
                                <app-icon class="mobile-links__item-arrow" name="arrow-rounded-down-12x7" size="12x7">
                                </app-icon>
                            </button>
                        </div>
                        <div class="mobile-links__item-sub-links" *ngIf="siteService.siteSetting?.contactUs" appCollapseContent>
                            <ul class="mobile-links mobile-links--level--1" appCollapse>
                                <li *ngIf="siteService.siteSetting.contactUs.phone">
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i class="footer-contacts__icon fas fa-mobile-alt"></i> <span style="direction: ltr;">{{siteService.siteSetting.contactUs.phone}}</span></div>
                                        </div>
                                    </div>
                                </li>
                                <li *ngIf="siteService.siteSetting.contactUs.timing">
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i class="footer-contacts__icon far fa-clock"></i> {{siteService.siteSetting.contactUs.timing}}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li *ngIf="siteService.siteSetting.contactUs.email">
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i class="footer-contacts__icon far fa-envelope"></i> {{siteService.siteSetting.contactUs.email}}
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li *ngIf="siteService.siteSetting.contactUs.address">
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link d-flex">
                                                <i class="footer-contacts__icon fas fa-globe-americas"></i>
                                                {{siteService.siteSetting.contactUs.address}}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <!-- #DEP to be deprecated -->

                        <div class="mobile-links__item-sub-links" *ngIf="!siteService.siteSetting?.contactUs" appCollapseContent>
                            <ul class="mobile-links mobile-links--level--1" appCollapse>
                                <li>
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i class="footer-contacts__icon fas fa-mobile-alt"></i> <span style="direction: ltr;">13380333</span></div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i class="footer-contacts__icon far fa-clock"></i> Sun-Thu 8:00 - 17:00
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i class="footer-contacts__icon far fa-envelope"></i> info&#64;qetaat.com
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link"><i class="footer-contacts__icon far fa-envelope"></i> order&#64;qetaat.com
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="mobile-links__item">
                                        <div class="mobile-links__item-title">
                                            <div class="mobile-links__item-link d-flex">
                                                <i class="footer-contacts__icon fas fa-globe-americas"></i>
                                                <a class="ms-2" href=" https://goo.gl/maps/vJAf5EhGDL7LYuFo8"> Office
                                                    42, Building 657 (Jeera III), Road 2811, 428 Seef District, Kingdom
                                                    of Bahrain</a>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="bottom-nav d-md-none d-flex justify-content-center">
    <button class="nav-item" (click)="searchDropdownToggle($event);">
        <div class="nav-icon">
            <app-icon name="search-20" size="24"></app-icon>
        </div>
        <div class="nav-label text-uppercase">{{"Search"|translate}}</div>
    </button>
    <a class="nav-item" (click)="onItemClick($event)" [routerLink]="((sector) ? ['/sector', sector] : ['/']).concat(['site','stores'])">
        <div class="nav-icon">
            <app-icon name="store-20" size="24"></app-icon>
        </div>
        <div class="nav-label text-uppercase">{{"stores"|translate}}</div>
    </a>
    <a class="nav-item" (click)="onItemClick($event)" [routerLink]="['/site','professionals']">
        <div class="nav-icon">
            <app-icon name="store-20" size="24"></app-icon>
        </div>
        <div class="nav-label text-uppercase">{{"professionals"|translate}}</div>
    </a>
    <a class="nav-item" (click)="onItemClick($event)" [routerLink]="['/account/quotations']">
        <div class="nav-icon">
            <app-icon name="quotation-20" size="24"></app-icon>
            <div class="badge">{{quotationCart.quantity$|async}}</div>
        </div>
        <div class="nav-label text-uppercase">{{"quotations"|translate}}</div>
    </a>
    <a class="nav-item" (click)="onItemClick($event)" [routerLink]="['/cart']">
        <div class="nav-icon">
            <app-icon name="cart-20" size="24"></app-icon>
            <div class="badge">{{cart.quantity$|async}}</div>
        </div>
        <div class="nav-label text-uppercase">{{"cart"|translate}}</div>
    </a>
    <!-- <a class="nav-item" (click)="onItemClick($event)" [routerLink]="['/account/dashboard']">
        <div class="nav-icon">
            <app-icon name="person-20" size="24"></app-icon>
        </div>
        <div class="nav-label text-uppercase">{{"profile"|translate}}</div>
    </a> -->
</div>